import React, { useCallback, useState } from 'react'
import { ModalBody, Form, FormGroup, Label } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { DropDownList } from '@/components/dropDownList'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { useLocalization } from '@/hooks/localization'
import Resx from '@/components/Resx'
import { DatePicker } from '@/components/DatePicker'
import context from '@/context'

function ImpersonationDialog ({ item, onAction, ...rest }) {
  const { localize } = useLocalization()
  const [state, setState] = useState(item)
  const { impersonatedUserId, impersonatorUserId, impersonatorUser, validFrom, validTo } = state
  const impersonators = useCallback((request, options) => {
    if (!request) request = {}
    if (!request.filter) request.filter = { logic: 'and', filters: [] }
    request.filter.filters.push({ field: 'id', operator: 'neq', value: impersonatedUserId })
    return context.api.userService.getLookup(request, options)
  }, [impersonatedUserId])
  const impersonatorChanged = useCallback(({ value, item }) => {
    setState(state => ({ ...state, impersonatorUserId: value, impersonatorUser: item }))
  }, [])
  const validFromChanged = useCallback((value) => {
    setState(state => ({ ...state, validFrom: value }))
  }, [])
  const validToChanged = useCallback((value) => {
    setState(state => ({ ...state, validTo: value }))
  }, [])
  return (
    <ValidationBoundary>
      <BasicHeader title='UsersManagement.ImpersonationAssignment' {...rest} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <FormGroup>
              <Label>{localize('UsersManagement.Impersonator')}</Label>
              <Validator name='impersonatorUserId' value={impersonatorUserId} required>
                <DropDownList
                  dataSource={impersonators}
                  onChange={impersonatorChanged}
                  value={impersonatorUser}
                  textField={'name'}
                  valueField={'id'} />
              </Validator>
            </FormGroup>
            <FormGroup>
              <Label><Resx name='Common.ValidFrom' />:</Label>
              <DatePicker
                value={validFrom}
                onChange={validFromChanged} />
            </FormGroup>
            <FormGroup>
              <Label><Resx name='Common.ValidTo' />:</Label>
              <DatePicker
                value={validTo}
                onChange={validToChanged} />
            </FormGroup>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...rest} primaryButtonText='Common.SaveAndClose' icon='save' onAction={() => onAction(state)} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: ImpersonationDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/impersonation.js